/**
 * The one rule every number on the parcel card shares, shared by the card and the weight rows
 * inside it: a carrier cannot quote on a parcel that weighs or measures nothing.
 *
 * It says so by turning the field red and nothing more. The input takes digits only and refuses
 * anything below its min, so zero is the one wrong number that can reach it - and a field showing
 * a zero it will not accept needs no sentence to explain itself.
 */
import { IInputValitationResponse } from "../../../../../../../../hooks/input-validation-hook";

/** Emptiness is left to required; this only turns away a number that cannot be shipped. */
export const greaterThanZero = (value: number | null): IInputValitationResponse => ({
    isValid: value === null || value > 0,
    messages: [],
});
